import _regeneratorRuntime from "/Users/Bas/repos/projects/catafolk/website/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import * as log from './log';
import * as options from './options';
import * as set from './set';
import * as sort from './sort';
import * as get from './get';
import * as staticMethods from './static';

function Cite(data) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!(this instanceof Cite)) {
    return new Cite(data, options);
  }

  this._options = options;
  this.log = [];
  this.data = [];
  this.set(data, options);
  this.options(options);
  this.save();
  return this;
}

Object.assign(Cite.prototype, log, options, set, sort, get);
Cite.prototype[Symbol.iterator] = /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          return _context.delegateYield(this.data, "t0", 1);

        case 1:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, this);
});
Object.assign(Cite, staticMethods);
export default Cite;